import { render, staticRenderFns } from "./MPHeader.vue?vue&type=template&id=72439232&scoped=true"
import script from "./MPHeader.vue?vue&type=script&lang=js"
export * from "./MPHeader.vue?vue&type=script&lang=js"
import style0 from "./MPHeader.vue?vue&type=style&index=0&id=72439232&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72439232",
  null
  
)

export default component.exports